import { render, staticRenderFns } from "./ExpenseFilter.vue?vue&type=template&id=0fff1f8d"
import script from "./ExpenseFilter.vue?vue&type=script&lang=js"
export * from "./ExpenseFilter.vue?vue&type=script&lang=js"
import style0 from "./ExpenseFilter.vue?vue&type=style&index=0&id=0fff1f8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports